import { createSlice } from "@reduxjs/toolkit";

type OptionType = {
  label: string;
  value: string;
  unitList?: string[]; // Adding unitList as an array of strings
};

type filterOptionsType = {
  loading: boolean;
  data: {
    communities: OptionType[];
    paymentType: OptionType[];
    paymentstatus: OptionType[];
    chargesList: OptionType[];
  };
};

type DarnaDetailsType = {
  darnaPoints: string;
  darnaAmount: string;
  slabKey: string;
};

const initialState: {
  selectedInvoices: any[];
  isSelectionEnabled: boolean;
  payAllEnabled: boolean;
  editDisabled: boolean;
  filterOptions: filterOptionsType;
  totalAmount: number;
  paymenDetails: any;
  statementDetails: any;
  soaDetails: {};
  totalOutstanding: number;
  soaFilter: any;
  routeHistory: string;
  darnaDetails: DarnaDetailsType;
} = {
  selectedInvoices: [],
  isSelectionEnabled: false,
  payAllEnabled: false,
  editDisabled: false,
  totalAmount: 0,
  filterOptions: {
    loading: false,
    data: {
      communities: [],
      paymentType: [],
      paymentstatus: [],
      chargesList: [],
    },
  },
  paymenDetails: {},
  statementDetails: {},
  soaDetails: {},
  totalOutstanding: 0,
  soaFilter: {},
  routeHistory: "",
  darnaDetails: { darnaPoints: "", darnaAmount: "", slabKey: "" },
};

const serviceFeeJourneySlice = createSlice({
  name: "serviceFeeJourneySlice",
  initialState: initialState,
  reducers: {
    setCurrentServicePaymentJourney: (state, action): any => {
      return action.payload;
    },
    updateCurrentServicePaymentJourney: (state, action): any => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetPaymentServiceRetry: (state): any => {
      const newState: any = initialState;
      delete newState.paymentProcessCompleted;
      return {
        newState,
      };
    },
    setFilterLoading: (state: any, action) => {
      if (!state.filterOptions) {
        state.filterOptions = { loading: false, data: [] };
      }
      state.filterOptions.loading = action.payload;
    },
    setFilterOptions: (state, action) => {
      state.filterOptions.data = action.payload;
      state.filterOptions.loading = false;
    },
    setPaymentDetails: (state, action) => {
      state.paymenDetails = action.payload;
    },
    setStatementDetails: (state, action) => {
      state.statementDetails = action.payload;
    },
    setSoaData: (state, action) => {
      state.soaDetails = action.payload;
    },
    setTotalOutstanding: (state, action) => {
      state.totalOutstanding = action.payload;
    },
    setSoaFilter: (state, action) => {
      state.soaFilter = action.payload;
    },
    setRouteHistory: (state, action) => {
      state.routeHistory = action.payload;
    },
    setDarnaDetails: (state, action) => {
      state.darnaDetails = {
        ...state.darnaDetails,
        ...action.payload,
      };
    },
  },
});
export const {
  setCurrentServicePaymentJourney,
  updateCurrentServicePaymentJourney,
  resetPaymentServiceRetry,
  setFilterLoading,
  setFilterOptions,
  setPaymentDetails,
  setStatementDetails,
  setSoaData,
  setTotalOutstanding,
  setSoaFilter,
  setRouteHistory,
  setDarnaDetails,
} = serviceFeeJourneySlice.actions;
export default serviceFeeJourneySlice.reducer;
